import { Locale } from 'modules/i18n';

export const cachedRequestsCardTranslation = {
  [Locale.en]: {
    title: 'Cached Requests',
  },
};
